import { render, staticRenderFns } from "./UnauthorizedAccess.vue?vue&type=template&id=1b6b5fdd&scoped=true"
import script from "./UnauthorizedAccess.vue?vue&type=script&lang=js"
export * from "./UnauthorizedAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b5fdd",
  null
  
)

export default component.exports